import { addDays, addYears, format, isToday, isTomorrow, subDays } from "date-fns";
import React, { useState } from "react";
import "./style.scss";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import pl from "date-fns/locale/pl";
import ModalComponent from "../../../../features/ModalComponent";
import EAIconButton from "../Buttons/EAIconButton";
import EADayCalendar from "../EADayCalendar/EADayCalendar";

interface IProps {
  selectedDate: Date;
  setSelectedDate: (value: Date) => void;
}

const SingleDateSelector: React.FC<IProps> = ({ selectedDate, setSelectedDate }) => {
  const [openCalendar, setOpenCalendar] = useState(false);

  const getDateLabel = () => {
    if (isToday(selectedDate)) {
      return "Dzisiaj";
    } else if (isTomorrow(selectedDate)) {
      return "Jutro";
    } else {
      return format(selectedDate, "EEEE dd.MM", { locale: pl });
    }
  };

  const handlePreviousDay = () => {
    setSelectedDate(subDays(selectedDate, 1));
  };

  const handleNextDay = () => {
    setSelectedDate(addDays(selectedDate, 1));
  };

  const handleSelectDate = (date: Date) => {
    setSelectedDate(date);
    setOpenCalendar(false);
  };

  return (
    <>
      <div className="single-date-select-wrapper">
        {!isToday(selectedDate) && (
          <EAIconButton title="Poprzedni dzień" onClick={handlePreviousDay} icon={<MdOutlineKeyboardArrowLeft />} />
        )}

        <div className="date-label" onClick={() => setOpenCalendar(true)}>
          {getDateLabel()}
        </div>
        <EAIconButton title="Następny dzień" onClick={handleNextDay} icon={<MdOutlineKeyboardArrowRight />} />
      </div>

      {openCalendar && (
        <ModalComponent
          footer
          open
          closeModal={() => setOpenCalendar(false)}
          title="Wybór dnia"
          onAccept={() => handleSelectDate(selectedDate)}
        >
          <EADayCalendar
            selectedDate={selectedDate}
            onSelect={handleSelectDate}
            fromDate={new Date()}
            toDate={addYears(new Date(), 1)}
          />
        </ModalComponent>
      )}
    </>
  );
};

export default SingleDateSelector;
